export const selectVideoBySeed = (videos: string[], seed: number): string | null => {
    if (videos.length === 0) return null;

    let value = seed >>> 0;
    value += 0x6D2B79F5;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);

    const randomValue = ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    return videos[Math.floor(randomValue * videos.length)];
};
